export default function createSaveButtonLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `save-button:${input.type}` });
    return {
        replacementSkipped(reason) {
            return log({
                type: "replacement-skipped",
                details: { reason },
            });
        },
        replaced(elementText) {
            return log({
                type: "replaced",
                details: { elementText },
            });
        },
        clicked() {
            return log({
                type: "clicked",
            });
        },
        saveStarted(info) {
            return log({
                type: "save-started",
                details: info,
            });
        },
        saveFinished(success) {
            return log({
                type: "save-finished",
                details: { success },
            });
        },
        originalClicked() {
            return log({
                type: "original-clicked",
            });
        },
    };
}
